import axios, { withToken } from './axios'
import { PaymentMethod, PaymentMethodPayload } from '@/models'

export async function fetchPaymentMethods (): Promise<PaymentMethod[]> {
  const response = await axios.get<PaymentMethod[]>(
    '/v2/payment/payments/payment-methods'
  )

  return response.data
}

export async function fetchAllowedPaymentMethods (
  accountId: number,
  businessUnitId: number
): Promise<PaymentMethod[]> {
  const response = await axios.get<PaymentMethod[]>(
    `/v2/payment/payments/providers/${accountId}/locations/${businessUnitId}/payment-methods`
  )

  return response.data
}

export async function fetchAllowedPaymentMethod (
  token: string,
  accountId: number,
  businessUnitId: number,
  id: number
) {
  const response = await axios.get<PaymentMethod>(
    `/v2/payment/payments/providers/${accountId}/locations/${businessUnitId}/payment-methods/${id}`,
    withToken(token)
  )

  return response.data
}

export async function bindPaymentMethod (
  token: string,
  accountId: number,
  businessUnitId: number,
  payload: PaymentMethodPayload
): Promise<PaymentMethod> {
  const response = await axios.post<PaymentMethod>(
    `/v2/payment/payments/providers/${accountId}/locations/${businessUnitId}/payment-methods/${payload.id}`,
    { isPublic: payload.public },
    withToken(token)
  )

  return response.data
}

export async function unbindPaymentMethod (
  token: string,
  accountId: number,
  businessUnitId: number,
  id: number
): Promise<void> {
  await axios.delete<void>(
    `/v2/payment/payments/providers/${accountId}/locations/${businessUnitId}/payment-methods/${id}`,
    withToken(token)
  )
}

export async function updatePaymentMethod (
  token: string,
  accountId: number,
  businessUnitId: number,
  payload: PaymentMethodPayload
): Promise<PaymentMethod> {
  const response = await axios.put<PaymentMethod>(
    `/v2/payment/payments/providers/${accountId}/locations/${businessUnitId}/payment-methods/${payload.id}`,
    { isPublic: payload.public },
    withToken(token)
  )

  return response.data
}

export default {
  bindPaymentMethod,
  fetchAllowedPaymentMethod,
  fetchAllowedPaymentMethods,
  fetchPaymentMethods,
  unbindPaymentMethod,
  updatePaymentMethod
}
